(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["kenisys-ai-landing"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('click', async (event) => {
    const button = event.target.closest('[data-kai-buy-now]');
    if (!button || button.disabled || button.dataset.loading === 'true') return;

    event.preventDefault();
    button.dataset.loading = 'true';
    button.disabled = true;

    const root = window.Shopify?.routes?.root || '/';

    try {
      const clearResponse = await fetch(root + 'cart/clear.js', {
        method: 'POST',
        headers: { 'Accept': 'application/json' }
      });

      if (!clearResponse.ok) throw new Error('Unable to clear cart');

      const addResponse = await fetch(root + 'cart/add.js', {
        method: 'POST',
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          items: [{
            id: Number(button.dataset.variantId),
            quantity: 1
          }]
        })
      });

      if (!addResponse.ok) throw new Error('Unable to add product');

      window.location.assign(root + 'checkout');
    } catch (error) {
      button.dataset.loading = 'false';
      button.disabled = false;
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["kenisys-workflow-os"] && !Shopify.designMode) return;
  try {
    
  let kwosCheckoutBusy = false;
  document.addEventListener('submit', async (event) => {
    const form = event.target;
    if (!(form instanceof HTMLFormElement) || !form.matches('.kwos__buy-form')) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    if (kwosCheckoutBusy) return;
    const variantId = form.querySelector('[name="id"]')?.value;
    if (!variantId) return;
    kwosCheckoutBusy = true;
    const buttons = [...form.closest('.kwos').querySelectorAll('.kwos__buy-form button')];
    const states = buttons.map(button => button.disabled);
    buttons.forEach(button => { button.disabled = true; });
    form.setAttribute('aria-busy', 'true');
    let error = form.querySelector('[role="alert"]');
    if (error) error.remove();
    const root = window.Shopify?.routes?.root || '/';
    const post = async (path, body) => {
      const response = await fetch(root + path, {
        method: 'POST',
        credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify(body)
      });
      const data = await response.json();
      if (!response.ok) throw new Error(data.description || data.message || 'Unable to start checkout. Please try again.');
      return data;
    };
    try {
      await post('cart/clear.js', {});
      await post('cart/add.js', { items: [{ id: variantId, quantity: 1 }] });
      window.location.assign(root + 'checkout');
    } catch (failure) {
      error = document.createElement('p');
      error.setAttribute('role', 'alert');
      error.textContent = failure.message || 'Unable to start checkout. Please try again.';
      form.append(error);
      buttons.forEach((button, index) => { button.disabled = states[index]; });
      form.removeAttribute('aria-busy');
      kwosCheckoutBusy = false;
    }
  }, true);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
